module.exports = __webpack_public_path__ + "static/media/logo.f04af9c6.webp";